const initialState = {
	accounts: null,
	loading: false,
	error: null
}

const accounts = (state = initialState, action) => {
	switch (action.type) {
		case 'RESET_APP':
			return { ...initialState }
		case 'CLEAR_ACCOUNTS':
			return { ...state, accounts: null, loading: false, error: null }
		case 'GET_ACCOUNTS':
			return { ...state, loading: true, error: null }
		case 'SET_ACCOUNTS':
			return { ...state, accounts: action.payload, loading: false, error: null }
		case 'GET_ACCOUNTS_FAIL':
			return { ...state, loading: false, error: action.payload }
		case 'CREATE_ACCOUNTS':
			return { ...state, loading: true, error: null }
		case 'CREATE_ACCOUNTS_FAIL':
			return {
				...state,
				loading: false,
				error: action.payload || 'An error occured while updating contacts.'
			}
		case 'UPDATE_ACCOUNTS':
			return { ...state, loading: true, error: null }
		case 'UPDATE_ACCOUNTS_SUCCESS':
			let account = action.payload
			let accountsToUpdate = state.accounts

			if (accountsToUpdate && accountsToUpdate.length) {
				let accountIndex = accountsToUpdate.findIndex((a) => a._id === account._id)

				if (accountIndex !== -1) {
					accountsToUpdate[accountIndex] = { ...account }
				}
			}

			return { ...state, accounts: [...accountsToUpdate], loading: false, error: null }
		case 'UPDATE_ACCOUNTS_FAIL':
			return { ...state, loading: false, error: 'An error occured while updating accounts.' }
		default:
			return state
	}
}

export default accounts
